import apiClient from "./apiClient";

export const listPinnedItems = async ({ viewUserId } = {}) => {
  const response = await apiClient.get("/pinned-items", {
    params: viewUserId ? { view_user_id: Number(viewUserId) } : undefined,
  });
  return Array.isArray(response.data) ? response.data : [];
};

export const pinItem = async ({ itemType, itemId }) => {
  const response = await apiClient.post("/pinned-items", {
    item_type: itemType,
    item_id: String(itemId),
  });
  return response.data;
};

export const unpinItem = async ({ itemType, itemId }) =>
  apiClient.delete(`/pinned-items/${encodeURIComponent(itemType)}/${encodeURIComponent(String(itemId))}`);

export const getPinnedItemStates = async (items) => {
  const response = await apiClient.post("/pinned-items/states", {
    items: items.map((item) => ({
      item_type: item.itemType,
      item_id: String(item.itemId),
    })),
  });
  return response.data?.states || {};
};
